import { AccountTypeEnum, PointsPeriodType, getDelegatorPoints } from '@kudos/http-client'
import { useMemberPoints } from '@shared/hooks/useMemberPoints'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export const parsePeriodTypeFromPeriod = (
  period: string | null | undefined,
): PointsPeriodType | undefined => {
  if (period?.includes('Q')) {
    return PointsPeriodType.QUARTER
  }
  if (period?.includes('M')) {
    return PointsPeriodType.MONTH
  }
  return undefined
}

export const usePointsPeriodType = (delegatorId?: string) => {
  const { allocationAccount } = useMemberPoints(undefined, [], !delegatorId)

  const { data: delegatorAccounts } = useQuery({
    queryKey: ['delegatorPoints', delegatorId],
    queryFn: () => getDelegatorPoints(delegatorId ?? ''),
    enabled: !!delegatorId,
  })

  const period = delegatorId
    ? delegatorAccounts?.find(account => account.type === AccountTypeEnum.ALLOCATION)?.period
    : allocationAccount?.period

  return useMemo(() => parsePeriodTypeFromPeriod(period), [period])
}
